import React from 'react';
import Heading from '../../../../../../generic-components/Heading';

interface IProps {
    title: string;
    value: string;
}

export const SubTotalAmount = ({ title, value }: IProps) => (
  <div className='flex items-center justify-between grow py-[18px] px-[16px] border-b border-bw03'>
    <Heading title={title} className='font-metric text-[14px] text-bw08' />
    <Heading id='subTotalValue' title={value} className='font-metric text-[14px] text-bw08' />
  </div>
);
